import React from "react";
import { Calendar,CircleCheck, X } from "lucide-react";
import { Badge, Divider, Card } from "antd";
import { actions } from "./actions";


const LeaveRequestsCard = ({ data }) => {
    const leaveRequests = data ?? actions.filter(a => a.category === "Leave Requests");
    if (leaveRequests.length === 0) return null;  

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1.5 mb-2 text-blue-600">
        <Calendar className="w-3.5 h-3.5"/>
        <h3 className="text-[12px]">
          Leave Requests
        </h3>
        <Badge
          count={leaveRequests.length}
          size="small"
          style={{
            backgroundColor: "rgb(43 127 255)",
            color: "#ffffff",
            border: "none",
            fontSize: "9px",
          }}
        />
      </div>

      {leaveRequests.map(
        ({
          id,
          name,
          role,
          leaveType,
          days,
          startDate,
          endDate,
          dateRequested,
          reason,
          priority,
        }) => (
          <Card
            key={id}
            className="rounded-2xl border pr-2 space-y-2"
          >
            <div className="flex justify-between items-start">
              <span
                className={`absolute right-5 text-[10px] status-indicator h-4  ${priority}`}>
                {priority}
              </span>

              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-green-50 text-[11px] text-green-700 font-semibold shrink-0">
                  {name
                    ? name
                      .split(" ")
                      .slice(0, 2)
                      .map((n) => n[0])
                      .join("")
                    : ""}
                </div>
                <div>
                  <div className="flex flex-row gap-2">
                    <h3 className="text-xs text-gray-800 ">{name}</h3>
                  </div>
                  <div className="flex items-center text-gray-600 text-[11px]">
                    {role}
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-2 gap-1 my-2">
              <div>
                <p className="text-xs text-gray-500 mb-1">Type</p>
                <div className="flex items-center gap-1">
                  <span className="text-xs ">{leaveType}</span>
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500 mb-1">Duration</p>
                <div className="flex items-center gap-1">
                  <span className="text-xs ">
                    {days} day{days > 1 ? "s" : ""}
                  </span>
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500 mb-1">Start Date</p>
                <div className="flex items-center gap-1">
                  <span className="text-xs ">{startDate}</span>
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500 mb-1">End Date</p>
                <div className="flex items-center gap-1">
                  <span className="text-xs ">{endDate}</span>
                </div>
              </div>
            </div>

            <div>
              <p className="text-xs text-gray-500 mb-1">Reason</p>
              <p className="text-xs ">{reason}</p>
            </div>

            <Divider
              style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }}
            />

            <div className="flex gap-3 justify-between">
              <div className="inline-flex gap-1">
                <p className="text-xs text-gray-500">Submitted: </p>
                <div className="flex gap-1">
                  <span className="text-xs ">{dateRequested}</span>
                </div>
              </div>
              <div className="inline-flex gap-2">
                <button
                  className="w-full rounded-xl border px-2 py-0.5 flex items-center gap-1 text-[11px]"
                >
                  <X size={12} /> Reject
                </button>
                <button
                  className="w-full rounded-xl bg-green-700 border px-2 py-0.5 flex items-center gap-1 text-[11px] text-white"
                >
                  <CircleCheck size={12} /> Approve
                </button>
              </div>
            </div>
          </Card>
        )
      )}
    </div>
  );
};

export default LeaveRequestsCard;
